export default {
  buttons: {
    next: "다음",
    prev: "이전",
    skip: "건너뛰기",
    done: "완료",
    gotIt: "확인",
  },
  messages: {
    dontShowAgainLabel: "다시 보지 않기",
    stepNumbersOfLabel: "/",
  },
};
